var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { fontWeight, colors, shadows, gradients, easing, mq } from "core/styles/snippets";
export var Button = function (_a) {
    var onClick = _a.onClick, className = _a.className, children = _a.children, props = __rest(_a, ["onClick", "className", "children"]);
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(StyledButton, __assign({ className: className, onClick: onClick }, props), children));
};
var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0.625rem 1rem;\n  border: 0;\n  color: ", ";\n  border-radius: 1.59375rem;\n  cursor: pointer;\n  ", "\n  ", "\n  ", "\n  transition: all 0.25s ", ";\n\n    ", "{\n        &:hover{\n            ", "\n        }\n    }\n"], ["\n  padding: 0.625rem 1rem;\n  border: 0;\n  color: ", ";\n  border-radius: 1.59375rem;\n  cursor: pointer;\n  ", "\n  ", "\n  ", "\n  transition: all 0.25s ", ";\n\n    ", "{\n        &:hover{\n            ", "\n        }\n    }\n"])), colors.white, fontWeight.bold, shadows.button, gradients.primaryGradient, easing.expo.out, mq.hover("hover"), gradients.primaryGradientHover);
var templateObject_1;
